import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-3 px-6" }
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = {
  key: 0,
  class: ""
}
const _hoisted_4 = {
  key: 0,
  class: "min-w-full divide-y divide-gray-200 table-striped"
}
const _hoisted_5 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5 w-8/12" }
const _hoisted_6 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["colspan"]
const _hoisted_10 = {
  key: 1,
  class: "ml-auto p-6 w-1/4"
}
const _hoisted_11 = { key: 1 }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
// import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import TabComponent from '@/components/TabComponent.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import PagePagination from '@/components/PagePagination.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import FileImportModal from '@/components/modal/FileImportModal.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import ActivityLogsTable from '@/components/ActivityLogsTable.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';

import draggable from "vuedraggable";
import throttle from "lodash/throttle";
import IllnessCondition from "@/classes/IllnessCondition";

import { paginatePage } from '@/helpers/PageHelper';
import { useRouter } from 'vue-router';
import { onMounted, ref, watch, computed } from 'vue';

/**
 * ********************************
 * Data 
 * ********************************
 */
 
export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router           = useRouter();
 const loader           = ref(false);
 const showError        = ref(false);
 const errorMsg         = ref(null);
 const dialog           = ref(false)
 const seletected       = ref();
 const showConfirmation = ref(false);
 const showSuccess      = ref(false);
//  const illnessId        = ref(route.params.id)
 const mainRoute        = ref(`/contents/conditions`);
 const currentRoutePath = computed(() => router.currentRoute.value.path);

// Query
 const searchText = ref();
 const activeTab  = ref();
 const goToPage   = ref();
 const tab        = ref('all');

/**
 * ********************************
 * Page Renderer Data 
 * ********************************
 */
const items           = ref(null);
const items_count     = ref(null);
const rows            = ref(null);
const query           = ref(null);
const selected_tab    = ref('all');
const filterDate       = ref(null);
const log_event       = ref(null);
const log_query       = ref(null);
const log_date        = ref(null);
const active_count    = ref(null);
const archived_count  = ref(null);
const log_counts      = ref(null);
const logs            = ref(null);
const log_event_lists = ref(null);
// Tabs
const tabs: { name: string, count: number, allowed: boolean }[] = computed(() => [
    {
        name: 'Active',
        count: active_count.value,
        href: mainRoute.value,
        allowed: true
    },
    {
        name: 'Archived',
        count: archived_count.value,
        href: `${mainRoute.value}/archived`,
        allowed: true
    },
    {
        name: 'Activity Logs',
        count: log_counts.value,
        href: `${mainRoute.value}/logs`,
        allowed:
            window.$hasPermission('view-activity-logs')
    }
]);

// Headers
const headers: { text: string }[] = [
    { text: 'ILLNESS/CONDITION' },
    { text: 'Date Created'}
];

/**
 * ********************************
 * Methods
 * ********************************
 */
const indexIllnessCondition = async (data: string) => {
    loader.value = true;

    const queryString     = searchText.value ? `&query=${searchText.value}` : 'query';
    const dateQuery       = filterDate.value ? `&filterDate=${filterDate.value}` : '';
    const isArchivedRoute = currentRoutePath.value === `${mainRoute.value}/archived`;
    const tabValue        = isArchivedRoute ? 'archived' : tab.value;
    const goToPageValue   = paginatePage(data);
    const records  =    `&rows=${recordsPerPage.value}`;
    
    try  {
        const response = await IllnessCondition.indexIllnessCondition(`${goToPageValue}&tab=${tabValue}&${queryString}&${dateQuery}&${records}`)

        loader.value          = false;
        items.value           = response.data.items;
        items_count.value     = response.data.items_count
        rows.value            = response.data.rows
        query.value           = response.data.query
        selected_tab.value    = response.data.selected_tab
        filterDate.value       = response.data.filterDate
        log_event.value       = response.data.log_event
        log_query.value       = response.data.log_query
        log_date.value        = response.data.log_date
        active_count.value    = response.data.active_count
        archived_count.value  = response.data.archived_count
        log_counts.value      = response.data.log_counts
        logs.value            = response.data.logs
        log_event_lists.value = response.data.log_event_lists

    }catch(error) {
        loader.value = false;
        showError.value = true;
        errorMsg.value = error.response.data.message;
        
        if(error.response.status == 401) {
            window.location.replace('/login');
        }
    }
}

const applyFilters = () => {
    indexIllnessCondition(goToPage.value)
}

const searchData = (val: string) => {
    searchText.value = val
}

const openModal = () => {
    dialog.value = true;
}

const recordsPerPage = ref(10);
const records = ref([
    { id: '10', label: '10', value: '10' },
    { id: '25', label: '25', value: '25' },
    { id: '50', label: '50', value: '50' },
    { id: '100', label: '100', value: '100' },
    { id: '500', label: '500', value: '500' },
])

watch(
    () => recordsPerPage.value,
    () => {
        indexIllnessCondition(goToPage.value)
    }
);

/**
 * ********************************
 * Archive 
 * ********************************
 */
 const selectedCondition = (id: string) => {
    showConfirmation.value = true
    seletected.value = id
}

const archiveCondition = async () => {
    try {
        loader.value = true;
        await IllnessCondition.deleteIllnessCondition(seletected.value);
        loader.value = false;
        window.location.replace('/contents/conditions/archived');
    } catch (err) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err?.response?.data.message;
    }
};

/**
 * ********************************
 * Restore 
 * ********************************
 */
 const restoreCondtion = async (id: string) => {
    try {
        loader.value = true;
        await IllnessCondition.restoreIllnessCondition(id);
        loader.value = false;
        window.location.replace('/contents/conditions')
    } catch (err) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err?.response?.data.message;
    }
};

/**
 * ********************************
 * Export Data 
 * ********************************
 */
 const exportData = async () => {
    try {
        loader.value = true;
        const params = currentRoutePath.value === `${mainRoute.value}/archived` ? 'tab=archived' : '';

        await IllnessCondition.exportIllnessCondition(params);
        showSuccess.value = true;
    } catch (error) {
        showError.value = true;
        errorMsg.value  = error.response?.data.message;
    } finally {
        loader.value = false;
    }
};

const reorder = (order) => {
    loader.value = true;

    IllnessCondition.reorderIllnessCondition(order)
        .then(() => {
            loader.value      = false;
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

watch(
      searchText,
      throttle(() => {
        indexIllnessCondition(goToPage.value)
      }, 1000)
    );


onMounted( () => indexIllnessCondition(goToPage.value));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, { title: "Illnesses/Conditions" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, {
          tabs: tabs.value,
          "button-items": true
        }, {
          buttons: _withCtx(() => [
            _createVNode(ButtonComponent, {
              class: "text-gray-900",
              secondary: "",
              exportBtn: "",
              onClick: exportData,
              disabled: loader.value
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode(" Export ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(ButtonComponent, {
              onClick: openModal,
              class: "text-gray-900",
              secondary: "",
              importBtn: ""
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode(" Import ", -1)
              ]))]),
              _: 1
            }),
            (_ctx.$hasPermission('create-content'))
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 0,
                  createBtn: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(`/contents/conditions/create`)))
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode(" Create ", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["tabs"])
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FilterComponent, {
          search: searchText.value,
          onFetchData: searchData,
          "text-filters": currentRoutePath.value !== '/contents/conditions/logs',
          "onUpdate:filters": applyFilters,
          "custom-filters": activeTab.value !== 'activity_logs'
        }, {
          fields: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(DatePicker, {
                id: "filterDate",
                name: "filterDate",
                range: "",
                is24: "",
                isPresetRanges: "",
                modelValue: filterDate.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterDate).value = $event)),
                placeholder: "Start Date & End Date",
                label: "Start Date & End Date"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["search", "text-filters", "custom-filters"])
      ]),
      (currentRoutePath.value !== '/contents/conditions/logs')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (items.value?.data)
              ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
                  _cache[16] || (_cache[16] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        scope: "col",
                        class: "relative px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      }, " ILLNESS/CONDITION "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "relative px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                      }, " Date Created "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "relative px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      }, " Actions ")
                    ])
                  ], -1)),
                  _createVNode(_unref(draggable), {
                    modelValue: items.value.data,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((items.value.data) = $event)),
                      _cache[3] || (_cache[3] = ($event: any) => (reorder($event)))
                    ],
                    tag: "tbody",
                    "item-key": "name",
                    class: "bg-white divide-y divide-gray-200"
                  }, {
                    item: _withCtx(({ element }) => [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_5, _toDisplayString(element.name), 1),
                        _createElementVNode("td", _hoisted_6, _toDisplayString(element.formatted_created_at), 1),
                        _createElementVNode("td", _hoisted_7, [
                          (_ctx.$hasPermission('update-content'))
                            ? (_openBlock(), _createBlock(ActionButton, {
                                key: 0,
                                "edit-btn": "",
                                onClick: ($event: any) => (_unref(router).push(`/contents/conditions/edit/${element.id}`))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (!element.deleted_at && _ctx.$hasPermission('archive-content'))
                            ? (_openBlock(), _createBlock(ActionButton, {
                                key: 1,
                                "delete-btn": "",
                                onClick: ($event: any) => (selectedCondition(element.id))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (element.deleted_at && _ctx.$hasPermission('restore-content'))
                            ? (_openBlock(), _createBlock(ActionButton, {
                                key: 2,
                                "restore-btn": "",
                                onClick: ($event: any) => (restoreCondtion(element.id))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (items.value?.data.length == 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                        _createElementVNode("td", {
                          class: "whitespace-nowrap text-center",
                          colspan: 
                                headers.length + (!_ctx.noAction ? 1 : 0)
                            
                        }, [...(_cache[15] || (_cache[15] = [
                          _createElementVNode("div", { class: "text-sm text-gray-400 py-4" }, " No data to display. ", -1)
                        ]))], 8, _hoisted_9)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (items.value?.data.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(MultiselectInput, {
                    id: "records_per_page",
                    label: "Records Per Page",
                    modelValue: recordsPerPage.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((recordsPerPage).value = $event)),
                    placeholder: "Records Per Page",
                    options: records.value
                  }, null, 8, ["modelValue", "options"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(PagePagination, {
              class: "mb-6",
              items: items.value,
              onNextPage: indexIllnessCondition
            }, null, 8, ["items"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(ActivityLogsTable, {
              logs: logs.value,
              onFetchIndex: indexIllnessCondition
            }, null, 8, ["logs"])
          ])),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 2 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[7] || (_cache[7] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[8] || (_cache[8] = ($event: any) => {showConfirmation.value = false; archiveCondition()}),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Archive Illnesses/Conditions ?",
        content: "Are you sure you wish to archive this Illness/Condition ?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[9] || (_cache[9] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[10] || (_cache[10] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Illnesses/Conditions Export",
        content: "Export is being processed. Please check your registered email."
      }, null, 8, ["show"]),
      _createVNode(FileImportModal, {
        title: "Illnesses/Conditions",
        dialog: dialog.value,
        "import-route": `illness-conditions/import`,
        onOnClose: _cache[11] || (_cache[11] = ($event: any) => (dialog.value = false)),
        "manifest-file-url": "/assets/files/illnesses-conditions.xlsx"
      }, null, 8, ["dialog"])
    ]),
    _: 1
  }))
}
}

})